import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';

import { Store } from '@ngrx/store';

import { OsUpdateStatesStoreActions, OsUpdateStatesStoreStates } from '../os-update-state/index';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class OsUpdateStatesResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly osUpdatesStore: Store<OsUpdateStatesStoreStates.OsUpdateStatusState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.osUpdatesStore.dispatch(
          OsUpdateStatesStoreActions.OsUpdateStatesResolverActions.osUpdateStateRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
